export default "__VITE_ASSET__BdS2XKat__"